// export const colors = {
//   // line0:  '#FF0000',
//   line0:  '#1E88E5',
//   line1:  '#FB8C00',
//   line2:  '#00C853',
//   line3:  '#C15EAF',
//   line4:  '#00B8D9',
//   line5:  '#DF4949',
//   line6:  '#FFB300',
//   line7:  '#6C5CE7',
//   line8:  '#00897B',
//   line9:  '#F4511E',
//   line10: '#5CB91A',
//   line11: '#8E24AA',
//   line12: '#29B6F6',
//   line13: '#EF5350',
//   line14: '#9CCC65',
//   line15: '#5E35B1',
//   line16: '#FFA726',
//   line17: '#2FB2AD',
//   line18: '#E91E63',
//   line19: '#66BB6A',
//   line20: '#3949AB',
//   line21: '#FF7043',
//   line22: '#AB47BC',
//   line23: '#F7CC00',
//   line24: '#D81B60',
//   line25: '#82C6D7',
//   line26: '#6081EE',
//   line27: '#BA9762',
//   line28: '#EC407A',
//   line29: '#7E57C2',
//   line30: '#9B603E',
//   line31: '#F2BDDE',
//   line32: '#B0CB1D',
// };

export const colors = { 
  line0: '#1E88E5',
  line1: '#FB8C00', 
  line2: '#00C853', 
  line3: '#C287E8', 
  line4: '#FF7043', 
  line5: '#E1CA96', 
  line6: '#FF3C38', 
  line7: '#06b2bc', 
  line8: '#F7567C', 
  line9: '#791E94', 
  line10: '#F7CC00', 
  line11: '#B0CB1D', 
  line12: '#DC0073', 
  line13: '#39EFF9', 
  line14: '#FFE45C', 
  line15: '#5EFDA0', 
  line16: '#E5CCF5', 
  line17: '#FFA185', 
  line18: '#F2E7CF', 
  line19: '#FF8785', 
  line20: '#7FBBF0', 
  line21: '#F98AA4', 
  line22: '#C467E0', 
  line23: '#FFBF70', 
  line24: '#D8EB70', 
  line25: '#FF47A6', 
};

export const COLORS_QTY = Object.keys(colors).length;